import React, { useState } from 'react';

// Styles
import {
	ContentWrapperStyled,
	SearchInputStyled,
	SearchInputContainerStyled,
	SearchInputWrapperStyled,
	DropdownSelectStyled,
	DropdownOptionStyled,
	DropdownSelectContainerStyled,
	DropdownSelectWrapperStyled,
	FilterLabelStyled,
} from './Filter.styled';

import {
	SearchIconStyled,
	CloseIconStyled,
	DownArrowIconStyled,
} from '../../library/Icons.styled';

const Filter = (props) => {
	const {
		dropdownFilters,
		allowInteraction,
		setCourseFilter,
		currentFilter,
		currentSearch,
	} = props;

	// Keep track of the current state
	const [getSearch, setSearch] = useState(currentSearch);
	const [getFilter, setFilter] = useState(currentFilter);

	const onSearchChange = (event) => {
		setSearch(event.target.value);
		setCourseFilter(event.target.value, getFilter);
	};

	const onFilterChange = (event) => {
		setFilter(event.target.value);
		setCourseFilter(getSearch, event.target.value);
	};

	const onClickResetSearch = () => {
		// Reset
		setSearch('');
		setCourseFilter('', getFilter);
	};

	const onFocus = () => {
		// On focus hide the overlay
		allowInteraction();
	};

	return (
		<ContentWrapperStyled>
			<SearchInputContainerStyled>
				<FilterLabelStyled>
					Search for location, postcode or title:
				</FilterLabelStyled>
				<SearchInputWrapperStyled>
					<SearchInputStyled
						onFocus={onFocus}
						onChange={onSearchChange}
						value={getSearch}
						type="text"
						placeholder="Search..."
					/>
					{currentSearch !== '' ? (
						<CloseIconStyled
							onFocus={onFocus}
							onClick={() => onClickResetSearch()}
							className={'search-reset'}
						/>
					) : (
						<SearchIconStyled />
					)}
				</SearchInputWrapperStyled>
			</SearchInputContainerStyled>
			<DropdownSelectContainerStyled>
				<FilterLabelStyled>Filter by level:</FilterLabelStyled>
				<DropdownSelectWrapperStyled>
					<DropdownSelectStyled onChange={onFilterChange} value={getFilter}>
						{dropdownFilters.map((entry, index) => (
							<DropdownOptionStyled key={index} value={entry.key}>
								{entry.name}
							</DropdownOptionStyled>
						))}
					</DropdownSelectStyled>
					<DownArrowIconStyled />
				</DropdownSelectWrapperStyled>
			</DropdownSelectContainerStyled>
		</ContentWrapperStyled>
	);
};

export default Filter;
